import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UIService } from '../shared/ui.service';
import { Observable } from 'rxjs/index';
import { Client } from './client';
import { environment } from '../../environments/environment';
import { User } from '../auth/user.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private http: HttpClient,
    private uiService: UIService
  ) { }

  getProfile(token): Observable<Client> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/profile/';
    return this.http.get<Client>(url, {
      headers: headers
    });
  }

  updateProfile(token, client: Client): Observable<User> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = client;
    const url = environment.APIEndpoint + 'client-api/profile/';
    return this.http.put<User>(url, body, {
      headers: headers
    });
  }
}
